import React from 'react';
import StepTwoForm from './StepTwoForm';

const StepTwo = () => {
  return (
    <div className="w-full">
      <StepTwoForm />
    </div>
  )
}

export default StepTwo